import React, { FunctionComponent, useState } from 'react'
import { injectIntl, InjectedIntlProps, FormattedMessage } from 'react-intl'
import CloseIcon from '@uniiverse/library/assets/icons/x.svg'

import { ModalComponent as Modal } from 'src/elements/Modal/Modal'
import { Card } from 'src/elements/Card'

import { locale } from './locale'

import { getItem, setItem } from '../../lib/local-storage.js'

const style = require('./aip-enabled-modal.css')

export const AIP_CONFIRM_STORAGE = 'aip_modal_confirmed'

interface Props {
  eventSlug: String
}

const AipModalComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventSlug,
  intl: { formatMessage },
}) => {
  const [open, setOpen] = useState(true)

  const getStorageArray = () => {
    const currentStorageRaw = getItem(AIP_CONFIRM_STORAGE) || []
    try {
      return JSON.parse(currentStorageRaw)
    } catch {
      return []
    }
  }

  const storeAgree = () => {
    const newStorageArray = getStorageArray()
    try {
      newStorageArray.push(eventSlug)
      const stringifiedStorageArray = JSON.stringify(newStorageArray)
      setItem(AIP_CONFIRM_STORAGE, stringifiedStorageArray)
    } catch {
      // Don't update the storage if there's something wrong with the data
    }

    setOpen(false)
  }

  if (getStorageArray()?.includes(eventSlug)) return null

  return (
    <Modal showModal={open} onClose={() => setOpen(false)}>
      <Card>
        <div className={style.header}>
          {formatMessage(locale.importantInfo)}
          <CloseIcon className={style.closeIcon} onClick={() => setOpen(false)} />
        </div>
        <div className={style.optInText}>
          <FormattedMessage
            {...locale.hostOptedIn}
            values={{
              aipText: <strong>{formatMessage(locale.aip)}</strong>,
            }}
          />
          <span>{' '}</span>
          <FormattedMessage
            {...locale.whatAipMeans}
            values={{
              totalText: <strong>{formatMessage(locale.totalUpFront)}</strong>,
            }}
          />
        </div>
        <div className={style.buttonContainer}>
          <button className={style.button} onClick={() => storeAgree()}>{formatMessage(locale.iAgree)}</button>
        </div>
      </Card>
    </Modal>
  )
}

export const AipModal = injectIntl(AipModalComponent)
